import { Injectable } from '@angular/core';
import { JsonConvert, ValueCheckingMode } from 'json2typescript';

@Injectable({
  providedIn: 'root'
})
export class JsonService {

  private jsonConvert: JsonConvert = new JsonConvert();

  constructor() {
    this.jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
  }

  serializeObject(object: any): string {
    return JSON.stringify(object);
  }

  serializeObjectAsync(object: any): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      try {
        resolve(JSON.stringify(object));
      } catch (e) {
        reject(e);
      }
    });
  }

  deserializeObject<T extends object>(jsonObject: any, classReference: new () => T): T {
    return this.jsonConvert.deserialize(jsonObject, classReference) as T;
  }

  deserializeObjectAsync<T extends object>(jsonObject: any, classReference: new () => T): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      try {
        resolve(this.jsonConvert.deserialize(jsonObject, classReference) as T);
      } catch (e) {
        reject(e);
      }
    });
  }

  deserializeArray<T extends object>(jsonObject: any, classReference: new () => T): T[] {
    return this.jsonConvert.deserialize(jsonObject, classReference) as T[];
  }

  deserializeArrayAsync<T extends object>(jsonObject: any, classReference: new () => T): Promise<T[]> {
    return new Promise<T[]>((resolve, reject) => {
      try {
        resolve(this.jsonConvert.deserialize(jsonObject, classReference) as T[]);
      } catch (e) {
        reject(e);
      }
    });
  }
}
